const StoryDeleted = () => {
  return null;
}
 
export default StoryDeleted;